module.exports = "/_next/static/images/DevOpsDaysIndia2-466175d5f27b349cd199f155d39119cc.jpg";